import { Button } from '@eo/shared';

type Props = {
  onRetry: () => void;
};

export function AuthCallbackError({ onRetry }: Props) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="max-w-md rounded-16 border border-border-faint bg-[var(--color-canvas-base)] p-8 text-center">
        <h1 className="text-lg font-semibold text-text-primary">Sign-in failed</h1>
        <p className="mt-2 text-sm text-text-tertiary">
          We couldn&apos;t complete the sign-in. This is usually transient.
        </p>
        <Button className="mt-4" onClick={onRetry}>
          Try again
        </Button>
      </div>
    </div>
  );
}
